import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {actions as AreaActions} from '../../../redux/modules/Area'
import {actions as MarkTypesActions} from '../../../redux/modules/MarkType'
import {actions as MarkRulesActions} from '../../../redux/modules/MarkRules'
import {actions as RegistrationActions} from '../../../redux/modules/Registration'
import RegistrationMark from "./RegistrationMark";
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'

const mapStateToProps = (state) => {
    return {
        registration: state.registration,
        markTypes: state.markTypes,
        markRules: state.markRules
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch,
        areaActions: bindActionCreators(AreaActions, dispatch),
        markRulesActions: bindActionCreators(MarkRulesActions, dispatch),
        markTypesActions: bindActionCreators(MarkTypesActions, dispatch),
        registrationActions: bindActionCreators(RegistrationActions, dispatch)
    };
};

class RegistrationMarkContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedMark: null,
            formErrors: null
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    getFreeMark(marks) {
        if(marks.length === 0) {
            return null;
        }
        let freeMarks = marks.filter(item => item.free);
        if(freeMarks.length === 0) {
            return marks[0];
        }

        return freeMarks[0];
    }

    getVehicleTypesByRules(markRule) {
        if(markRule.vehiclePropertyType) {
            return markRule.vehiclePropertyType.split(", ").map(item => ({
                name: item
            }));
        }

        return [
            {name:"Proprietà"},
            {name:"Noleggio"},
            {name:"Comodato d'uso"},
            {name:"Auto Aziendale"},
            {name:"Auto Aziendale in uso esclusivo"},
            {name:"Proprietà Aziendale"},
        ];
    }


    componentWillMount() {

        if(!this.props.registration.userInfoInitialized) {
            this.props.history.push('/register');
            return;
        }

        const markRulesActions = this.props.markRulesActions;
        const registration = this.props.registration;
        const markTypes = this.props.markTypes;
        const self = this;
        SostaOnlineApiService.fetchMarkTypesByCategoryAndAreaId(
            registration.userInfo.userCategories[0].name,
            registration.userInfo.areaId).then(data => {

                self.props.markTypesActions.saveMarkTypes(data.data);

                if(data.data.length === 0) {
                    return;
                }

                let selectedMark = this.getFreeMark(data.data);
                this.setState({selectedMark: selectedMark}, () => {
                    self.props.markRulesActions.fetchMarkRulesByCategoryAndAreaAndMark(
                        this.props.registration.userInfo.userCategories[0].name,
                        this.props.registration.userInfo.areaId,
                        selectedMark.name);
                });
        });
    }

    onSubmit(values) {
        this.setState({formErrors: null});
        if(!values.captcharesponse) {
            this.setState({formErrors: "Devi dimostrare di non essere un robot"});
            return;
        }

        let user = {
            ...this.props.registration.userInfo,
            userCategories: [this.props.registration.userInfo.userCategories[0].id],
            ...values,
            markTypeId: this.state.selectedMark.id
        };

        SostaOnlineApiService.register(user).then(data => {

            this.props.registrationActions.clear();
            this.props.history.push('/register/completed');
        }).catch(err => {
            console.log(err);
            this.setState({formErrors: "Errore durante la registrazione"});
        });
    }

    render() {
        if(!this.props.markTypes.data || !this.props.markRules.data) {
            return(<div>Caricamento in corso...</div>);
        }

        if(this.props.markTypes.data.length === 0 || !this.state.selectedMark) {
            return(<div className="text-center" style={{marginTop: 10, marginBottom: 10}}>
                <h4>Non sono disponibili contrassegni agevolati per la tua categoria</h4>
            </div>);
        }

        return(<RegistrationMark
                markType={this.state.selectedMark}
                vehicleTypes={this.getVehicleTypesByRules(this.props.markRules.data)}
                markRule={this.props.markRules.data}
                formErrors={this.state.formErrors}
                onSubmit={this.onSubmit} />);
    }
}

RegistrationMarkContainer.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationMarkContainer);




// WEBPACK FOOTER //
// ./src/containers/Registration/Mark/RegistrationMarkContainer.js